<template>
  <div class="section">
    <accordion-component :active="true" header="Parent Form">
      <!-- <parent-form-component v-bind:form="this.form"></parent-form-component> -->
      <div class="section">
        <vue-form-generator
          @validated="onValidated"
          tag="div"
          :schema="schema"
          :model="model"
          :options="formOptions"
        ></vue-form-generator>
      </div>
    </accordion-component>
    <accordion-component :active="false" header="Child Form">
      <!-- <child-form-component v-bind:form="this.form"></child-form-component> -->
      <div class="section">
        <!-- <vue-form-generator
          @validated="onValidated"
          tag="div"
          :schema="schema"
          :model="model"
          :options="formOptions"
        ></vue-form-generator>-->
      </div>
    </accordion-component>
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import AccordionComponent from "@/views/content/components/Accordion.vue";
// import ParentFormComponent from "@/views/pages/work/dev/ParentForm.vue";
// import ChildFormComponent from "@/views/pages/work/dev/ChildForm.vue";

export default {
  name: "ConditionalFormComponent",
  props: ["form"],
  components: {
    AccordionComponent,
    "vue-form-generator": VueFormGenerator.component
  },
  data() {
    return {
      model: {
        id: 1,
        parent: {
          first_name: "",
          last_name: "",
          address: {
            street: "",
            city: "",
            state: "",
            zip: ""
          },
          home_phone: "",
          cell_phone: "",
          email: ""
        },
        registration: {
          numChildren: 0
        },
        children: {
          first_name: "",
          last_name: "",
          gender: "",
          birthday: "",
          program: "",
          class: "",
          day: "",
          caregiver: {
            hasCaregiver: false,
            first_name: "",
            last_name: "",
            relationship: "",
            email: "",
            cell_phone: ""
          }
        }
      },
      schema: {
        groups: [
          {
            styleClasses: "columns is-multiline",
            legend: "Parent Details",
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "First Name",
                model: "parent.first_name",
                required: true,
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "text",
                label: "Last Name",
                model: "parent.last_name",
                required: true,
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "text",
                label: "Street",
                model: "parent.address.street",
                id: "street",
                required: true,
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.required
              },
              {
                type: "input",
                inputType: "text",
                label: "City",
                model: "parent.address.city",
                id: "city",
                required: true,
                styleClasses: "column is-3",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "text",
                label: "State",
                model: "parent.address.state",
                required: true,
                styleClasses: "column is-1",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "number",
                label: "Zip",
                model: "parent.address.zip",
                required: true,
                validator: VueFormGenerator.validators.integer,
                styleClasses: "column is-2"
              },
              {
                type: "cleave",
                label: "Home Phone",
                model: "parent.home_phone",
                cleaveOptions: {
                  phone: true,
                  phoneRegionCode: "US"
                },
                styleClasses: "column is-4"
              },
              {
                type: "cleave",
                label: "Cell Phone",
                model: "parent.cell_phone",
                required: true,
                cleaveOptions: {
                  phone: true,
                  phoneRegionCode: "US"
                },
                styleClasses: "column is-4",
                validator: VueFormGenerator.validators.required
              },
              {
                type: "input",
                inputType: "email",
                label: "Email",
                model: "parent.email",
                required: true,
                validator: VueFormGenerator.validators.email,
                styleClasses: "column is-4"
              },
              {
                type: "cleave",
                label:
                  "How many children would you like to register for Thrive?",
                model: "special",
                required: true,
                cleaveOptions: {
                  blocks: [1],
                  numericOnly: true
                },
                onChanged: (model, newVal, oldVal, field) =>
                  this.updateNumChildren(model, newVal, oldVal, field),
                styleClasses: "column",
                validator: VueFormGenerator.validators.required
              },
              {
                type: "submit",
                label: "",
                buttonText: "Submit",
                validateBeforeSubmit: true
              }
            ]
          },
          {
            styleClasses: "columns is-multiline child-section",
            legend: "Child Details",
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "First Name",
                id: "children.first_name",
                required: true,
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "text",
                label: "Last Name",
                id: "children.last_name",
                required: true,
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "select",
                label: "Gender",
                id: "children.gender",
                required: true,
                values: function() {
                  return [
                    { id: "female", name: "Female" },
                    { id: "male", name: "Male" },
                    { id: "other", name: "Other" },
                    { id: "prefer", name: "Prefer not to say" }
                  ];
                },
                selectOptions: {
                  noneSelectedText: "Please select one"
                },
                default: "en-US",
                validator: VueFormGenerator.validators.required,
                styleClasses: "column is-half"
              },
              {
                type: "input",
                inputType: "date",
                label: "Birthday",
                id: "children.birthday",
                required: true,
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.required
              },
              {
                type: "select",
                label: "Program Interest",
                id: "children.program",
                selectOptions: {
                  noneSelectedText: "Please select one"
                },
                values: function() {
                  return [
                    { id: "art", name: "Art" },
                    { id: "dance", name: "Dance" },
                    { id: "kindermusik", name: "Kindermusik" },
                    { id: "music_private", name: "Music Lessons (Private)" },
                    { id: "music_group", name: "Music Lessons (Group)" }
                  ];
                },
                onChanged: (model, newVal, oldVal, field) =>
                  this.updateSchema(newVal, field, model),
                styleClasses: "column is-4"
              },
              {
                type: "select",
                label: "Class Interest",
                id: "children.class",
                values: [],
                selectOptions: {
                  noneSelectedText: "Please select one"
                },
                onChanged: (model, newVal, oldVal, field) =>
                  this.updateSchema(newVal, field, model),
                styleClasses: "column is-4"
              },
              {
                type: "select",
                label: "Day Interest",
                id: "children.day",
                selectOptions: {
                  noneSelectedText: "Please select one"
                },
                values: [],
                styleClasses: "column is-4"
              },
              {
                type: "select",
                label: "Will there be another caregiver coming to class?",
                id: "children.caregiver.hasCaregiver",
                required: true,
                values: function() {
                  return [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }];
                },
                selectOptions: {
                  noneSelectedText: "Please select one"
                },
                default: "en-US",
                validator: VueFormGenerator.validators.required,
                styleClasses: "column is-12"
              },
              {
                type: "input",
                inputType: "text",
                label: "Caregiver's First Name",
                id: "children.caregiver.first_name",
                required: true,
                visible: (model, field, form) =>
                  model.children.caregiver.hasCaregiver === "yes",
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "text",
                label: "Caregiver's Last Name",
                id: "children.caregiver.last_name",
                required: true,
                visible: (model, field, form) =>
                  model.children.caregiver.hasCaregiver === "yes",
                styleClasses: "column is-half",
                validator: VueFormGenerator.validators.alpha
              },
              {
                type: "input",
                inputType: "text",
                label: "Relationship to Caregiver",
                id: "children.caregiver.relationship",
                required: true,
                visible: (model, field, form) =>
                  model.children.caregiver.hasCaregiver === "yes",
                styleClasses: "column is-4",
                validator: VueFormGenerator.validators.required
              },
              {
                type: "input",
                inputType: "email",
                label: "Caregiver's Email",
                id: "children.caregiver.email",
                required: true,
                validator: VueFormGenerator.validators.email,
                visible: (model, field, form) =>
                  model.children.caregiver.hasCaregiver === "yes",
                styleClasses: "column is-4"
              },
              {
                type: "cleave",
                label: "Caregiver's Cell Phone",
                id: "children.caregiver.cell_phone",
                required: true,
                cleaveOptions: {
                  phone: true,
                  phoneRegionCode: "US"
                },
                visible: (model, field, form) =>
                  model.children.caregiver.hasCaregiver === "yes",
                styleClasses: "column is-4",
                validator: VueFormGenerator.validators.required
              }
            ]
          }
        ]
      },
      // registrationSchema: {
      //   groups: [
      //     {
      //       styleClasses: "columns is-multiline",
      //       legend: "Registration Details",
      //       fields: [
      //         {
      //           type: "cleave",
      //           label:
      //             "How many children would you like to register for Thrive?",
      //           model: "special",
      //           required: true,
      //           cleaveOptions: {
      //             blocks: [1],
      //             numericOnly: true
      //           },
      //           onChanged: (model, newVal, oldVal, field) =>
      //             this.updateNumChildren(model, newVal, oldVal, field),
      //           styleClasses: "column",
      //           validator: VueFormGenerator.validators.required
      //         },
      //         {
      //           type: "submit",
      //           label: "",
      //           buttonText: "Submit",
      //           validateBeforeSubmit: true
      //         }
      //       ]
      //     }
      //   ]
      // },
      childSchema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: "First Name",
            id: "children.first_name",
            required: true,
            styleClasses: "column is-half",
            validator: VueFormGenerator.validators.alpha
          },
          {
            type: "input",
            inputType: "text",
            label: "Last Name",
            id: "children.last_name",
            required: true,
            styleClasses: "column is-half",
            validator: VueFormGenerator.validators.alpha
          },
          {
            type: "select",
            label: "Gender",
            id: "children.gender",
            required: true,
            values: function() {
              return [
                { id: "female", name: "Female" },
                { id: "male", name: "Male" },
                { id: "other", name: "Other" },
                { id: "prefer", name: "Prefer not to say" }
              ];
            },
            selectOptions: {
              noneSelectedText: "Please select one"
            },
            default: "en-US",
            validator: VueFormGenerator.validators.required,
            styleClasses: "column is-half"
          },
          {
            type: "input",
            inputType: "date",
            label: "Birthday",
            id: "children.birthday",
            required: true,
            styleClasses: "column is-half",
            validator: VueFormGenerator.validators.required
          },
          {
            type: "select",
            label: "Program Interest",
            id: "children.program",
            selectOptions: {
              noneSelectedText: "Please select one"
            },
            values: function() {
              return [
                { id: "art", name: "Art" },
                { id: "dance", name: "Dance" },
                { id: "kindermusik", name: "Kindermusik" },
                { id: "music_private", name: "Music Lessons (Private)" },
                { id: "music_group", name: "Music Lessons (Group)" }
              ];
            },
            onChanged: (model, newVal, oldVal, field) =>
              this.updateSchema(newVal, field, model),
            styleClasses: "column is-4"
          },
          {
            type: "select",
            label: "Class Interest",
            id: "children.class",
            values: [],
            selectOptions: {
              noneSelectedText: "Please select one"
            },
            onChanged: (model, newVal, oldVal, field) =>
              this.updateSchema(newVal, field, model),
            styleClasses: "column is-4"
          },
          {
            type: "select",
            label: "Day Interest",
            id: "children.day",
            selectOptions: {
              noneSelectedText: "Please select one"
            },
            values: [],
            styleClasses: "column is-4"
          },
          {
            type: "select",
            label: "Will there be another caregiver coming to class?",
            id: "children.caregiver.hasCaregiver",
            required: true,
            values: function() {
              return [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }];
            },
            selectOptions: {
              noneSelectedText: "Please select one"
            },
            default: "en-US",
            validator: VueFormGenerator.validators.required,
            styleClasses: "column is-12"
          },
          {
            type: "input",
            inputType: "text",
            label: "Caregiver's First Name",
            id: "children.caregiver.first_name",
            required: true,
            visible: (model, field, form) =>
              model.children.caregiver.hasCaregiver === "yes",
            styleClasses: "column is-half",
            validator: VueFormGenerator.validators.alpha
          },
          {
            type: "input",
            inputType: "text",
            label: "Caregiver's Last Name",
            id: "children.caregiver.last_name",
            required: true,
            visible: (model, field, form) =>
              model.children.caregiver.hasCaregiver === "yes",
            styleClasses: "column is-half",
            validator: VueFormGenerator.validators.alpha
          },
          {
            type: "input",
            inputType: "text",
            label: "Relationship to Caregiver",
            id: "children.caregiver.relationship",
            required: true,
            visible: (model, field, form) =>
              model.children.caregiver.hasCaregiver === "yes",
            styleClasses: "column is-4",
            validator: VueFormGenerator.validators.required
          },
          {
            type: "input",
            inputType: "email",
            label: "Caregiver's Email",
            id: "children.caregiver.email",
            required: true,
            validator: VueFormGenerator.validators.email,
            visible: (model, field, form) =>
              model.children.caregiver.hasCaregiver === "yes",
            styleClasses: "column is-4"
          },
          {
            type: "cleave",
            label: "Caregiver's Cell Phone",
            id: "children.caregiver.cell_phone",
            required: true,
            cleaveOptions: {
              phone: true,
              phoneRegionCode: "US"
            },
            visible: (model, field, form) =>
              model.children.caregiver.hasCaregiver === "yes",
            styleClasses: "column is-4",
            validator: VueFormGenerator.validators.required
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      }
    };
  },
  methods: {
    submit: function(model, schema) {
      this.onValidated();
      console.log(model);
      console.log(schema);
      alert("Form submitted!");
    },
    onValidated(isValid, errors) {
      console.log("Validation result: ", isValid, ", Errors:", errors);
    },
    setChildHeaders() {
      var existingHeaders = document.querySelectorAll(".child-header");
      [].forEach.call(existingHeaders, function(header, index) {
        header.remove();
      });

      var childSections = document.querySelectorAll(".child-section");

      [].forEach.call(childSections, function(section, index) {
        var newDiv = document.createElement("div");
        newDiv.classList.add("is-uppercase");
        newDiv.classList.add("child-header");

        var newContent = document.createTextNode("Child " + (index + 1));
        newDiv.appendChild(newContent);

        var hr = document.createElement("hr");
        newDiv.appendChild(hr);

        section.before(newDiv);
      });
    },
    updateNumChildren: function(model, newVal, oldVal, field) {
      var arr = [1, 2, 3, 4, 5];
      arr.splice(1, arr.length - 2);
      console.log(arr);

      for (var k = 0; k < 4; k++) {
        arr.splice(k + 1, 0, 3);
      }

      console.log(arr);
      // if (newVal < oldVal) {
      //   for (var j = 0; j < oldVal - newVal; j++) {
      //     this.registrationSchema.groups.pop();
      //   }
      // }

      this.schema.groups[0].fields.splice(
        1,
        this.schema.groups[0].fields.length - 2
      );

      for (var i = 1; i <= newVal; i++) {
        // this.$set(this.registrationSchema.groups[0],fields. i + 1, this.childSchema);
        this.schema.groups[0].fields.splice(i, 0, this.childSchema);
      }
      this.$nextTick(() => {
        this.setChildHeaders();
      });

      console.log(this.schema);
    },
    updateSchema: function(val, field, model) {
      var values = [];
      var schemaForm = this.registrationSchema.groups.find(
        field => field.legend === "Child Details"
      );

      if (field.model === "children.program") {
        var data = this.form.programData.find(
          e => e.id === model.children.program
        );

        var schemaInput = schemaForm.fields.find(
          field => field.model === "children.class"
        );

        var schemaInputDay = schemaForm.fields.find(
          field => field.model === "children.day"
        );

        schemaInputDay.values = [];

        for (var i = 0; i < data.classOptions.length; i++) {
          var obj = {
            id: data.classOptions[i].id,
            name: data.classOptions[i].label
          };
          values.push(obj);
        }
        schemaInput.values = values;
      } else if (field.model === "children.class") {
        var data = this.form.programData.find(
          e => e.id === model.children.program
        );

        var schemaInput = schemaForm.fields.find(
          field => field.model === "children.day"
        );

        var classData = data.classOptions.find(
          f => f.id === model.children.class
        );

        for (var i = 0; i < classData.dayOptions.length; i++) {
          values[i] = classData.dayOptions[i];
        }
        schemaInput.values = values;
      }
    },
    prettyJSON: function(json) {
      if (json) {
        json = JSON.stringify(json, undefined, 4);
        json = json
          .replace(/&/g, "&")
          .replace(/</g, "<")
          .replace(/>/g, ">");
        return json.replace(
          /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
          function(match) {
            var cls = "num";
            if (/^"/.test(match)) {
              if (/:$/.test(match)) {
                cls = "key";
              } else {
                cls = "string";
              }
            } else if (/true|false/.test(match)) {
              cls = "boolean";
            } else if (/null/.test(match)) {
              cls = "null";
            }
            return '<span class="' + cls + '">' + match + "</span>";
          }
        );
      }
    }
  }
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "../../../../assets/sass/colors.scss";

.child-header {
  color: #072d3d;
  font-weight: 700;
}

select {
  height: 34px;
}
</style>
